module.exports = __webpack_public_path__ + "f1ed6116a69b341510cc8550e7db1862.MP3";